import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Container from '../components/common/Container';

const Wrapper = styled.div`
  text-align: center;
  padding: 100px 20px;
`;

const Title = styled.h1`
  font-size: 72px;
  color: ${({ theme }) => theme.colors.primary};
`;

const Subtitle = styled.p`
  font-size: 24px;
  color: ${({ theme }) => theme.colors.dark};
  margin-bottom: 30px;
`;

const StyledLink = styled(Link)`
  font-size: 18px;
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: underline;
`;

const NotFoundPage = () => {
  return (
    <Container>
      <Wrapper>
        <Title>404</Title>
        <Subtitle>Página Não Encontrada</Subtitle>
        <StyledLink to="/">Voltar para a página inicial</StyledLink>
      </Wrapper>
    </Container>
  );
};

export default NotFoundPage;